module.exports = __webpack_public_path__ + "img/Ekstrafer_Sirop_Gray_1280x1010.d6c68ce7.jpg";